import { render, staticRenderFns } from "./LogedArea.vue?vue&type=template&id=401d4384"
import script from "./LogedArea.vue?vue&type=script&lang=js"
export * from "./LogedArea.vue?vue&type=script&lang=js"
import style0 from "./LogedArea.vue?vue&type=style&index=0&id=401d4384&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports